// 👇 Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// 👇 Axios Imports
import axios from 'axios'

import { urlFreightForwardService, urlIdentityService, urlOceanBookingService, urlTerminalService, urlCRMCompanyService, urlReportService, urlEquipmentService, urlEquipmentScheduleService } from '@src/endpoints'

import { getUriParams } from '@src/utility/Utils'
import { urlCleanlinessCertificate, urlReportingService } from '../../../../endpoints'
import { HttpTransportType, HubConnectionBuilder } from '@microsoft/signalr'

export const getAllData = createAsyncThunk('datasummreport/getTotalsDataSummReport', async params => {
  const DataSummTotalsModel = {
    fromDate: params.fromDate,
    toDate: params.toDate
  }
  const response = await axios.post(`${urlReportService}/getTotalsDataSummReport`, DataSummTotalsModel)
  return {
    data: response.data.data
  }
})

export const getData = createAsyncThunk('datasummreport/getDataSummReport', async params => {
  const uri = getUriParams(params)
  const DataSummFilter = {
    fromDate: params.fromDate,
    toDate: params.toDate
  }
  const response = await axios.post(`${urlReportService}/getDataSummReport?${uri}`, DataSummFilter)
  return {
    params,
    data: response.data.data,
    totalPages: response.data.totalCount
  }
})

export const getFFRequest = createAsyncThunk('ffRequests/getFFRequest', async id => {
  const response = await axios.get(`${urlFreightForwardService}/GetFFRequest/${id}`)
  const customer = await axios.get(`${urlIdentityService}/${response.data[0].customerUserId}`)
  return {
    selectedCustomer: customer.data.data[0],
    ffRequest: response.data[0],
    status: response.data[0].status,
    oceanBookings: response.data[0].oceanBookings,
    notes: response.data[0].notes
  }
})

export const getOceanBookingList = createAsyncThunk('ffRequests/getOceanBookingList', async oceanBookingIds => {
  const response = await axios.post(`${urlOceanBookingService}/getOceanBookingList`, oceanBookingIds)
  return {
    oceanBookingList: response.data.data.allData
  }
})

export const updateFFRequest = createAsyncThunk('ffRequests/updateFFRequest', async (FFRequestUpdateModel, { dispatch }) => {
  await axios.put(`${urlFreightForwardService}/UpdateFFRequest`, FFRequestUpdateModel)
  await dispatch(getFFRequest(FFRequestUpdateModel.id))
  return FFRequestUpdateModel
})

export const updateIngate = createAsyncThunk('movements/updateIngate', async (IngateUpdateModel, { dispatch }) => {
  await axios.put(`${urlTerminalService}/Update`, IngateUpdateModel)
  await dispatch(getFFRequest(IngateUpdateModel.id))
  return IngateUpdateModel
})

export const addNotes = createAsyncThunk('ffRequests/addNotes', async (FFNotesViewModel, { dispatch }) => {
  await axios.post(`${urlFreightForwardService}/AddFFNotes`, FFNotesViewModel)
  await dispatch(getFFRequest(FFNotesViewModel.FFRequestId))
  return FFNotesViewModel
})

export const updateStatus = createAsyncThunk('ffRequests/updateStatus', async (FFStatusUpdateModel, { dispatch }) => {
  await axios.post(`${urlFreightForwardService}/UpdateFFStatus`, FFStatusUpdateModel)
  await dispatch(getFFRequest(FFStatusUpdateModel.FFRequestId))
  return FFStatusUpdateModel
})

export const assignFFOceanBooking = createAsyncThunk('ffRequests/assignFFOceanBooking', async (FFOceanBookingAddModel, { dispatch }) => {
  const OceanBookingNumberModel = {
    OceanBookingNumber: FFOceanBookingAddModel.OceanBookingNumber
  }
  const OceanBookingId = await axios.post(`${urlOceanBookingService}/GetOceanBookingId`, OceanBookingNumberModel)
  const FFOceanBookingAssignModel = {
    FFRequestId: FFOceanBookingAddModel.FFRequestId,
    OceanBookingId: OceanBookingId.data.data.oceanBookigId,
    notes: FFOceanBookingAddModel.notes,
    noteType: FFOceanBookingAddModel.noteType
  }
  await axios.post(`${urlFreightForwardService}/AssignFFOceanBooking`, FFOceanBookingAssignModel)
  await dispatch(getFFRequest(FFOceanBookingAssignModel.FFRequestId))
  return FFOceanBookingAssignModel
})

export const getShipmentProgress = createAsyncThunk('ReportingService/GetAllShipmentProgressReportList', async (data) => {
  const { params, filter } = data

  const uri = getUriParams(params)

  const filterData = {
    vesselName: filter.vesselName || null,
    voyageNumbers: filter.voyageNumbers?.length > 0 ? filter.voyageNumbers : null,
    cargoCutOffFrom: filter.cargoCutOffFrom || null,
    cargoCutOffTo: filter.cargoCutOffTo || null,
    documentCutOffFrom: filter.documentCutOffFrom || null,
    documentCutOffTo: filter.documentCutOffTo || null,
    vgmCutOffFrom: filter.vgmCutOffFrom || null,
    vgmCutOffTo: filter.vgmCutOffTo || null,
    vgmStatus: filter.vgmStatus || null,
    // loadStatus: filter.loadStatus || null, // removed — no longer on the report
    docStatus: filter.docStatus || null,
    bookingNumber: filter.bookingNumber || null,
    ffNumber: filter.ffNumber || null,
    customer: filter.customer || null,
    destination: filter.destination || null,
    shippingLineCode: filter.shippingLineCode || null,
    upcomingDocCutOff: filter.upcomingDocCutOff || false,
    upcomingVGMCutOff: filter.upcomingVGMCutOff || false,
    assignedTo: filter.assignedTo || null
  }

  const response = await axios.post(`${urlReportingService}/GetAllShipmentProgressReportList?${uri}`, filterData)
  return {
    params,
    data: response.data.data,
    totalPages: response.data.totalCount,
    filterData
  }
})

export const getShipmentProgressCount = async () => {
  const response = await axios.get(`${urlReportingService}/GetShipmentProgressCount`)
  return {
    data: response.data
  }
}

export const updateShipmentProgressReportcutOffDate = async (data) => {
  const response = await axios.post(`${urlReportingService}/UpdateShipmentProgressReportCuttOffDate`, data)
  if (response.data.success) {
    return {
      success: true,
      data: response.data.data,
      message: response.data.messages
    }
  } else {
    return {
      success: false,
      message: response.data.errors[0]
    }
  }
}


// export const getFFMembers = async () => {
//   const response = await axios.get(`${urlIdentityService}/GetAllUsers?role=FreightForward`)
//   return response.data.data
// }

export const getFFMembers = createAsyncThunk('ffRequests/getFFMembers', async () => {
  const response = await axios.get(`${urlIdentityService}/GetAllUsers?role=FreightForward`)

  return response.data.data
})

export const assignTask = async (data) => {
  const response = await axios.post(`${urlReportingService}/AssignTask`, data)
  if (response.data.success) {
    return {
      success: true,
      data: response.data.data,
      message: response.data.messages
    }
  } else {
    return {
      success: false,
      message: response.data.errors[0]
    }
  }
}

export const getAllCleanlinessCertificateList = createAsyncThunk('CleanlinessCertificate/GetCleanlinessReport', async (data) => {
  const { params, filter } = data

  const uri = getUriParams(params)

  const filterData = {
    transloadOrderNumber: filter.transloadOrderNumber || null,
    bookingNumber: filter.bookingNumber || null,
    vesselName: filter.vesselName || null,
    terminalCode: filter.terminalCode || null,
    voyageNumber: filter.voyageNumber || null,
    customer: filter.customer || null
  }

  const response = await axios.post(`${urlCleanlinessCertificate}/GetAllCleanlinessCertificateList?${uri}`, filterData)
  return {
    params,
    data: response.data.data,
    totalPages: response.data.totalCount,
    filterData
  }
})

export const setCertificatesValidation = async ({ certificates, isValid, lastModifiedBy, attachmentsByItem = [] }) => {
  const formData = new FormData()
  formData.append('model', JSON.stringify({ certificates, isValid, lastModifiedBy }))
  attachmentsByItem.forEach((files, index) => {
    ;(files || []).forEach((file) => {
      formData.append(`certFiles_${index}`, file)
    })
  })
  const token = localStorage.getItem('accessToken')
  const response = await fetch(`${urlCleanlinessCertificate}/SetCertificatesValidation`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData
  })
  const json = await response.json()
  if (json.success) {
    return { success: true, data: json.data }
  } else {
    return { success: false, message: json.messages }
  }
}

// export const addCleanlinessCertificate = async (data) => {
//   const response = await axios.post(`${urlCleanlinessCertificate}/AddCleanlinessCertificate`, data)
//   if (response.data.success) {
//     return {
//       success: true,
//       data: response.data.data,
//       message: response.data.messages
//     }
//   } else {
//     return {
//       success: false,
//       message: response.data.errors[0]
//     }
//   }
// }

export const updateCleanlinessCertificatePicture = async (data) => {
  const response = await axios.post(`${urlCleanlinessCertificate}/UpdateCleanlinessCertificatePicture`, data)
  if (response.data.success) {
    return {
      success: true,
      data: response.data.data,
      message: response.data.messages
    }
  } else {
    return {
      success: false,
      message: response.data.errors[0]
    }
  }
}

export const addEquipmentInspectionPicture = async (data) => {
  const response = await axios.post(`${urlEquipmentService}/AddEquipmentInspectionPicture`, data)
  if (response.data.success) {
    return {
      success: true,
      data: response.data.data,
      message: response.data.messages
    }
  } else {
    return {
      success: false,
      message: response.data.errors[0]
    }
  }
}

export const getInboundData = createAsyncThunk('equipment/getData', async data => {
  const { params, filter } = data
  const uri = getUriParams(params)
  const filterData = {
    // movementType: 'schedule',
    yardLocation: filter.terminal || "",
    customerName: filter.customerName || "",
    line: filter.line || "",
    referenceNumber: filter.referenceNumber || "",
    equipmentStatus: filter.equipmentStatus || "",
    commodityType: filter.commodityType || "",
    equipmentType: filter.equipmentType || "ALL",
    from: filter.from || null,
    to: filter.to || null,
    destination: filter.destination || "",
    origin: filter.origin || "",
    cargoType: filter.cargoType || "",
    commodity: filter.commodity || "",
    grade: filter.grade || "",
    lotNumber: filter.lotNumber || "",
    lastTracedLocation: filter.lastTracedLocation || "",
    servingYard: filter.servingYard || "",
    tracingStatus: filter.tracingStatus || "",
    equipmentSize: filter.equipmentSize || "",
    shipper: filter.shipper || "",
    status: filter.status || ""
  }
  const response = await axios.post(`${urlEquipmentScheduleService}/GetScheduleEquipmentList?${uri}`, filterData)
  return {
    params,
    data: response.data.data,
    totalPages: response.data.totalCount,
    loaded: true,
    filterData
  }
})

export const getInboundTracingReportSummary = async data => {
  const { filter } = data

  const response = await axios.post(`${urlEquipmentService}/GetInboundTracingReportSummary`, filter)
  return {
    data: response.data.data
  }
}

export const getFFReport = createAsyncThunk('ffReports/getFFReport', async (param) => {
  const FFGeneratedReportModel = {
    FFOceanBookingId: param.id,
    ReportType: param.reportType
  }

  const response = await axios.get(`${urlFreightForwardService}/GetOceanBookingsId/${param.id}`)
  const responseReport = param.reportType === 'BookingConfirmation' ? await axios.get(`${urlOceanBookingService}/GetConfirmationReport/${response.data.oceanBookingId}`) : await axios.get(`${urlOceanBookingService}/GetDepartureNoticeReport/${response.data.oceanBookingId}`)
  const responseGenerated = await axios.post(`${urlFreightForwardService}/GetGeneratedReport`, FFGeneratedReportModel)
  const resAllDN = param.reportType === 'BookingConfirmation' ? await axios.get(`${urlFreightForwardService}/GetAllFFBookingConfirmationReport/${param.id}`) : await axios.get(`${urlFreightForwardService}/GetAllFFDepartureNoticeReport/${param.id}`)
  const selectedDN = param.rid !== undefined ? resAllDN.data.find(e => e.id === param.rid) : null
  const generatedBy = responseGenerated.data.length > 0 ? await axios.get(`${urlIdentityService}/${selectedDN !== null ? selectedDN.generatedBy : responseGenerated.data[0].generatedBy}`) : null
  return {
    departureNoticeReport: selectedDN !== null ? selectedDN.jsonReport : responseReport.data.data.allData,
    allDepartureNotice: resAllDN.data,
    generatedDate: selectedDN !== null ? selectedDN.generatedDate : responseGenerated.data.length > 0 ? responseGenerated.data[0].generatedDate : null,
    generatedBy: generatedBy !== null ? generatedBy.data.data[0] : null,
    ffRequestId: response.data.ffRequestId,
    ffNumber: response.data.ffNumber,
    noOfContainer: response.data.noOfContainer,
    customerName: response.data.customerName,
    shipperRefNumber: response.data.shipperRefNumber,
    goodsCollectedFrom: response.data.source,
    etdOrigin: response.data.etdOrigin,
    etaPortOfDestination: response.data.etaPortOfDestination,
    dLoaded: true
  }
})

// /ConfigCache/ContainerSize
export const getContainerSizeData = createAsyncThunk(
  "companyConfig/getContainerSizeData",
  async () => {
    const response = await axios.get(`${urlConfigCacheService}?type=ContainerSize`)
    return response.data ? response.data.sort((a, b) => a.id.localeCompare(b.id)) : []
  }
)

export const getAllWeightCertificateList = createAsyncThunk('cleanlinessCertificate/getAllWeightCertificateList', async (data) => {
  const { params, filter } = data

  const uri = getUriParams(params)

  const filterData = {
    transloadOrderNumber: filter.transloadOrderNumber || null,
    bookingNumber: filter.bookingNumber || null,
    vesselName: filter.vesselName || null,
    voyageNumber: filter.voyageNumber || null,
    terminalName: filter.terminalName || null,
    customer: filter.customer || null
  }

  const response = await axios.post(`${urlCleanlinessCertificate}/GetAllWeightCertificateList?${uri}`, filterData)
  return {
    params,
    data: response.data.data,
    totalPages: response.data.totalCount,
    filterData
  }
})

export const GetCompanyByCode = createAsyncThunk('cleanliness/GetCompanyByCode', async (terminal) => {
  const response = await axios.get(`${urlCRMCompanyService}/GetCompanyByCode/${terminal}`)
  return response.data
})

export const getAllDataSummaryReport = createAsyncThunk('datasummaryreport/getAllDataSummaryReport', async data => {
  const { params, filter } = data
  const uri = getUriParams(params)
  const filterData = {
    bookingNumber: filter.bookingNumber || null,
    fromDate: filter.fromDate || null,
    toDate: filter.toDate || null,
    yardLocation: filter.yardLocation || null,
    commoditySpecification: filter.commoditySpecification || null,
    commodityType: filter.commodityType || null,
    qualityAssuranceServiceProvider: filter.qualityAssuranceServiceProvider || null,
    inboundEquipmentNumber: filter.inboundEquipmentNumber || null,
    outboundEquipmentNumber: filter.outboundEquipmentNumber || null,
    commodityName: filter.commodityName || null
  }
  const response = await axios.post(`${urlReportingService}/GetAllDataSummaryReport?${uri}`, filterData)
  return {
    params,
    data: response.data.data,
    totalPages: response.data.totalCount,
    loaded: true,
    filterData
  }
})

// Typeahead lookup used by the Cleaning Log form: the Data Summary report is the only place that
// already joins an inbound equipment to its booking/commodity/grade/shipper, so we reuse its list
// endpoint (InboundEquipmentNumber is a Contains match server side) to suggest + prefill a side.
export const searchDataSummaryByEquipment = async (equipmentNumber, options = {}) => {
  const uri = getUriParams({ page: 1, perPage: options.perPage || 10, sort: 'desc', sortColumn: 'transactionDate' })
  const response = await axios.post(
    `${urlReportingService}/GetAllDataSummaryReport?${uri}`,
    { inboundEquipmentNumber: equipmentNumber },
    { signal: options.signal }
  )
  return response.data.data || []
}

export const getAllDataSummaryStats = async () => {
  const response = await axios.post(`${urlReportingService}/GetAllDataSummaryStats`, {})
  return {
    data: response.data
  }
}

export const getAllCleaningLogReport = createAsyncThunk('cleaninglog/getAllCleaningLogReport', async data => {
  const { params, filter } = data
  const uri = getUriParams(params)
  const filterData = {
    flush: filter.flush || null,
    bookingNumber: filter.bookingNumber || null,
    fromEquipment: filter.fromEquipment || null,
    toEquipment: filter.toEquipment || null,
    employeeName: filter.employeeName || null,
    customer: filter.customer || null,
    commodity: filter.commodity || null,
    endOfDayOnly: filter.endOfDayOnly || null,
    fromDate: filter.fromDate || null,
    toDate: filter.toDate || null
  }
  const response = await axios.post(`${urlReportingService}/GetAllCleaningLogReport?${uri}`, filterData)
  return {
    params,
    data: response.data.data,
    totalPages: response.data.totalCount,
    filterData
  }
})

export const addCleaningLogReport = async (data) => {
  const response = await axios.post(`${urlReportingService}/AddCleaningLogReport`, data)
  if (response.data.success) {
    return {
      success: true,
      data: response.data.data,
      message: response.data.messages
    }
  } else {
    return {
      success: false,
      message: response.data.errors[0]
    }
  }
}

export const updateCleaningLogReport = async (data) => {
  const response = await axios.post(`${urlReportingService}/UpdateCleaningLogReport`, data)
  if (response.data.success) {
    return {
      success: true,
      data: response.data.data,
      message: response.data.messages
    }
  } else {
    return {
      success: false,
      message: response.data.errors[0]
    }
  }
}

export const deleteCleaningLogReport = async (id) => {
  const response = await axios.delete(`${urlReportingService}/DeleteCleaningLogReport/${id}`)
  if (response.data.success) {
    return {
      success: true,
      data: response.data.data,
      message: response.data.messages
    }
  } else {
    return {
      success: false,
      message: response.data.errors[0]
    }
  }
}

export const getAllRailcarSpottingReportList = createAsyncThunk('railcarSpotting/getAllRailcarSpottingReportList', async data => {
  const { params, filter } = data
  const uri = getUriParams(params)

  const filterData = {
    fromDate: filter.fromDate || null,
    toDate: filter.toDate || null,
    yardLocation: filter.yardLocation || null,
    switchDeliveryStatus: filter.switchDeliveryStatus || null
  }

  const response = await axios.post(`${urlReportingService}/GetAllRailcarSpottingReportList?${uri}`, filterData)

  return {
    params,
    data: response.data.data,
    totalPages: response.data.totalCount,
    filterData
  }
})

export const getRailcarSpottingReport = async (reportId) => {
  const response = await axios.get(`${urlReportingService}/GetRailcarSpottingReport/${reportId}`)
  return response.data
}

//TODO
export const SignalRBuilder = () => {
  const connection = new HubConnectionBuilder()
    .withUrl(`${urlReportingService}/DashboardHub`, {
      skipNegotiation: true,
      transport: HttpTransportType.WebSockets
    })
    .withAutomaticReconnect()
    .build()

  return connection
}
// getAllQASamplingReport
export const getAllQASamplingReport = createAsyncThunk(
  'qaSamplingReport/getAllQASamplingReport',
  async (data) => {
    const { params, filter } = data
    const uri = getUriParams(params)

    const filterData = {
      transloadOrderNumber: filter.transloadOrderNumber || "",
      bookingNumber: filter.bookingNumber || "",
      inboundUnitNumber: filter.inboundUnitNumber || "",
      status: filter.status || "",
      serviceProvider: filter.serviceProvider || ""
    }

    const response = await axios.post(
      `${urlReportingService}/GetAllQASampleRequestReport?${uri}`,
      filterData
    )
    return {
      params,
      data: response.data.data,
      total: response.data.totalCount,
      filterData
    }
  }
)
export const updateQASamplingStatus = createAsyncThunk(
  'qaSamplingReport/updateQASamplingStatus',
  async (data) => {
    const updateModel = {
      id: data.id,
      status: data.status,
      notes: data.notes || ""
    }

    const response = await axios.post(
      `${urlReportingService}/UpdateQASampleRequestCommandReport`,
      updateModel
    )

    // ✅ Don't auto-refresh, just return the updated data
    return {
      success: response.data.success,
      message: response.data.messages?.[0] || 'Status updated successfully',
      data: response.data.data
    }
  }
)
export const ffRequestsSlice = createSlice({
  name: 'ffRequests',
  initialState: {
    data: [],
    total: 1,
    params: {},
    filter: {},
    allData: {},
    selectedCustomer: null,
    ffRequest: null,
    status: [],
    oceanBookings: [],
    oceanBookingList: [],
    cleanlinessCertificate: [],
    datasummaryreportstats: [],
    notes: [],
    loaded: false,
    dLoaded: false,
    dError: false,
    generatedDate: null,
    generatedBy: null,
    ffRequestId: null,
    ffNumber: null,
    shipperRefNumber: null,
    goodsCollectedFrom: null,
    allDepartureNotice: [],
    inboundSummary: []

  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getFFRequest.fulfilled, (state, action) => {
        state.selectedCustomer = action.payload.selectedCustomer
        state.ffRequest = action.payload.ffRequest
        state.status = action.payload.status
        state.oceanBookings = action.payload.oceanBookings
        state.notes = action.payload.notes
      })
      .addCase(getOceanBookingList.fulfilled, (state, action) => {
        state.oceanBookingList = action.payload.oceanBookingList
      })
      .addCase(getShipmentProgress.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.filter = action.payload.filterData
      })
      .addCase(getFFMembers.fulfilled, (state, action) => {
        state.ffMembers = action.payload
      })
      .addCase(getAllCleanlinessCertificateList.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.filter = action.payload.filterData
        state.loaded = true
      })
      .addCase(getAllCleanlinessCertificateList.rejected, (state) => {
        state.loaded = true
        state.data = []
      })
      .addCase(getAllCleanlinessCertificateList.pending, (state) => {
        state.loaded = false
      })
      .addCase(getInboundData.fulfilled, (state, action) => {
        state.loaded = true
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.filter = action.payload.filterData
      })
      .addCase(getInboundData.pending, state => {
        state.loading = true
        state.data = []
      })
      .addCase(getData.rejected, state => {
        state.loading = false
        state.data = []
      })
      .addCase(getFFReport.fulfilled, (state, action) => {
        state.dLoaded = action.payload.dLoaded
        state.departureNoticeReport = { ...action.payload.departureNoticeReport, generatedDate: action.payload.generatedDate, generatedBy: action.payload.generatedBy, shipperRefNumber: action.payload.shipperRefNumber, ffNumber: action.payload.ffNumber, ffRequestId: action.payload.ffRequestId, goodsCollectedFrom: action.payload.goodsCollectedFrom, noOfContainer: action.payload.noOfContainer, customerName: action.payload.customerName, etdOrigin: action.payload.etdOrigin, etaPortOfDestination: action.payload.etaPortOfDestination }
        state.generatedDate = action.payload.generatedDate
        state.generatedBy = action.payload.generatedBy
        state.ffRequestId = action.payload.ffRequestId
        state.ffNumber = action.payload.ffNumber
        state.shipperRefNumber = action.payload.shipperRefNumber
        state.goodsCollectedFrom = action.payload.goodsCollectedFrom
        state.allDepartureNotice = action.payload.allDepartureNotice
      })
      .addCase(getFFReport.rejected, (state) => {
        state.dLoaded = true
        state.dError = true
      })
      .addCase(getContainerSizeData.fulfilled, (state, action) => {
        state.containerSizes = action.payload
      })
      .addCase(getAllWeightCertificateList.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getAllDataSummaryReport.fulfilled, (state, action) => {
        state.loaded = true
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.filter = action.payload.filterData
      })
      .addCase(getAllCleaningLogReport.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.filter = action.payload.filterData
      })
      .addCase(getAllRailcarSpottingReportList.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.filter = action.payload.filterData
      })
      .addCase(getAllQASamplingReport.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.total
        state.filter = action.payload.filterData
        state.loaded = true
      })
      .addCase(getAllQASamplingReport.rejected, (state) => {
        state.loaded = true  // ✅ Set to true even on error
        state.data = []
      })
      .addCase(getAllQASamplingReport.pending, (state) => {
        state.loaded = false  // ✅ Set to false when loading starts
      })
      .addCase(updateQASamplingStatus.fulfilled, (state, action) => {
        // Optionally update specific record in state
        if (action.payload.data && state.data) {
          const index = state.data.findIndex(item => item.id === action.payload.data.id)
          if (index !== -1) {
            state.data[index] = { ...state.data[index], ...action.payload.data }
          }
        }
      })
  }
})

export default ffRequestsSlice.reducer
